import { contains } from 'ramda';

export const shouldAllowUnauthorized = path => contains(path || '', ALLOW_UNAUTH_PATHS);
